import React, { Component, useEffect } from "react";
import intl from "react-intl-universal";
import { ProgressBar } from "react-bootstrap";
import UploadingImages from "../../img/upload_icon.gif";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import { error } from "jquery";
import { egg } from "glyphicons";

class newPMProjectPhaseIII extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.startUploading();
        window.addEventListener('beforeunload', this.beforeUnloadHandler, true);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler, true);
    }

    componentDidUpdate() {
    }

    beforeUnloadHandler(e) {
        e.returnValue = 'Data may not be saved';
    }

    render() {
        return (
            <div style={{color: '#141414'}}>
                <div className="divWarningPMCloud" style={{backgroundColor: '#0186bc'}}>
                    <i className="fa fa-warning"></i>
                    {intl.get("PM_Cloud_PhaseIII_Do_Not_Close_Page")}
                </div>
                <div style={{ marginTop: "120px", textAlign: 'center' }}>
                    <img className="UploadingImages" src={UploadingImages}></img>
                    <h4 className="moreSpacefromTitleToTable" style={{ color: '#3185c0', marginTop: '20px', textAlign: 'center' }}>{intl.get("PM_Cloud_PhaseIII_Upload_Title")}</h4>
                    <h5>{intl.getHTML("PM_Cloud_PhaseIII_Upload_Description", { projectName: this.props.projectName, numOfImages: this.props.acceptedPhotos.length, accountPage: "\\store\\account" })}</h5>
                </div>

                <div style={{ marginTop: "80px" }}>
                    <div style={{ width: '100%', display: 'inline-block' }}>
                        <div style={{ float: 'left' }}>
                            <h5 style={{ width: '40%' }}>Uploading</h5>
                        </div>
                        <div style={{ float: 'right' }}>
                            <h5 style={{ width: '40%' }}>{this.props.progressState.toFixed(2) + `%`}</h5>
                        </div>
                    </div>
                    <ProgressBar now={this.props.progressState} label={this.props.progressState.toFixed(2) + `%`} />
                </div>
                <div style={{ marginTop: '70px' }}>
                    <h5>{intl.get("PM_Cloud_PhaseIII_Upload_Description_Steps_Title")}</h5>
                    <ol style={{color: '#767676'}}>
                        <li>{intl.get("PM_Cloud_PhaseIII_Upload_Description_Step_1")}</li>
                        <li>{intl.get("PM_Cloud_PhaseIII_Upload_Description_Step_2")}</li>
                        {this.props.isSubLoginType 
                        ? null 
                        : <li>{intl.get("PM_Cloud_PhaseIII_Upload_Description_Step_3")}</li>
                        }
                    </ol>
                    {this.props.isSubLoginType 
                        ? null 
                        : <p style={{color: '#767676'}}>{intl.getHTML("PM_Cloud_PhaseIII_Upload_Description_Steps", {accountPage: '/store/account?isCloudProcessing=true'})}</p>
                    }
                </div>
                <div className="NextPrevButtonsClass">
                    <div className="NextButtonDivClass" style={{ float: "right", marginRight: '40px', marginLeft: "30px" }}>
                        <button className="abortButton btn btn-default NextButtonClass" onClick={(event) => {
                            this.props.handleShowAbortDialog(true);
                            //this.props.handleAbortUploading();
                        }}>ABORT
                        </button>
                    </div>
                </div>
                <Dialog
                    open={this.props.showAbortDialog}
                    fullWidth
                    maxWidth={"sm"}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle
                        id="form-dialog-title"
                        className="PropertySheetDialogTitle"
                    >
                        {intl.get("PM_Cloud_PhaseIII_Abort_Dialog_Title")}
                    </DialogTitle>
                    <DialogContent>
                        <form className="mb-4">
                            <label className="mr-3">{intl.get("PM_Cloud_PhaseIII_Abort_Dialog_Aborting_Question")}</label>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <button
                            onClick={() => {
                                this.props.handleShowAbortDialog(false);
                            }}
                            className="btn btn-secondary btn-login text-capitalize mb-2 pl-4 pr-4 pt-1 pb-1"
                            color="primary"
                        >
                            No
                        </button>
                        <button
                            onClick={(event) => {
                                this.props.handleAbortUploading();
                            }}
                            className="btn btn-primary btn-login text-capitalize mb-2 pl-4 pr-4 pt-1 pb-1"
                            type="submit"
                            autoFocus
                            text="Yes"
                        >Yes</button>
                    </DialogActions>
                </Dialog>
            </div>
            
        )
    }
}

export default newPMProjectPhaseIII;
